import React from 'react';
import './index.scss';

// eslint-disable-next-line react/display-name
export default () => {
  return (
    <div className="article inner">
      <strong></strong>
      <a href="" target="_blank"></a>
      <h3>腾讯广告营销服务市场服务商合作协议</h3>
      <p>欢迎您使用腾讯广告营销服务市场服务！</p>
      <p>
        为使用腾讯广告营销服务市场服务（以下简称：本服务），您应当阅读并遵守《腾讯广告营销服务市场服务商合作协议》（以下简称:本协议）以及
        <a href="https://www.qq.com/contract.shtml" target="_blank" rel="noreferrer">
          《腾讯服务协议》
        </a>
        <a href="https://developers.e.qq.com/reg" target="_blank" rel="noreferrer">
          《腾讯广告Marketing API开发者服务协议》
        </a>
        <a href="https://ssl.zc.qq.com/chs/agreement1_chs.html" target="_blank" rel="noreferrer">
          《QQ号码规则》
        </a>
        <a
          href="https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=default"
          target="_blank"
          rel="noreferrer"
        >
          《腾讯微信软件许可及服务协议》
        </a>
        等相关协议、规则。
      </p>
      <p>
        本协议内容同时包括腾讯可能不断发布的关于本服务的相关协议、服务声明、业务规则及公告指引等专项规则。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。限制、免责条款可能以加粗或下划线形式提示您注意。
      </p>
      <p>
        除非您已阅读并接受本协议及相关协议、规则等的所有条款，否则，您无权使用本服务。一旦您选择“同意”（具体措辞以服务开通时页面实际显示为准）并完成注册流程，或您以任何方式使用本服务，即视为您已阅读并同意上述协议、规则等的约束。
      </p>
      <p>您违反本协议时，腾讯有权随时单方采取限制、中止或终止向您提供服务等措施，并有权追究您的法律责任。</p>

      <h4>1. 定义</h4>
      <p>如无特别说明，下列术语在本协议中的含义为：</p>
      <p>
        1.1
        腾讯广告营销服务市场服务商：指经有效注册后，将以其自身名义开发、创作或获得合法授权运营且独立承担法律责任的各种产品接入腾讯广告营销服务市场而向用户提供各种服务的法人或其他组织。如无特别说明，本协议中的“腾讯广告营销服务商市场服务商”简称为
        “您”。
      </p>
      <p>
        1.2
        产品：指由您以自身名义开发、创作，享有合法的运营权利，并进行运营和独立承担法律责任的，通过接入腾讯广告营销服务市场后向用户提供的应用程序及相关服务，包括但不限于数据分析类工具、智能投放类管理工具、私域运营工具、RTA工具、内容服务等已开发的各种服务及今后可能出现的各种服务。
      </p>
      <p>
        1.3 <strong>腾讯广告营销服务市场：</strong>
        指由腾讯所拥有、控制、经营的https://isv.e.qq.com/网站及其下属子页面，以下也简称为“服务市场”、“市场”。腾讯广告营销服务市场根据本协议向您提供中立的产品展示等服务（腾讯有权根据运营情况调整相关功能，具体服务内容以腾讯广告营销服务市场提供的功能为准，下称“本服务”）。
      </p>
      <p>
        1.4 <strong>用户：</strong>
        是指通过服务市场使用您提供的产品的主体，在本协议中用户应为已合法注册并开通腾讯广告服务平台相关账户的腾讯广告服务平台广告主或广告服务商。
      </p>
      <p>
        1.5 <strong>服务市场运营数据：</strong>
        是指用户以及您在使用服务市场中产生的相关数据，包括但不限于用户或您提交的数据、操作行为形成的数据等。
        <strong>
          服务市场运营数据的所有权及其他相关权利属于腾讯，且是腾讯的商业秘密，依法属于用户享有的相关权利除外。
        </strong>
      </p>
      <p>
        1.6 <strong>腾讯广告服务平台：</strong>
        指由腾讯或腾讯关联公司自主研发并运营的广告服务平台（包括腾讯广告投放管理平台、腾讯广告开发者平台等，具体以腾讯广告服务平台实际提供为准，简称“腾讯广告平台”），可提供流量采购、营销推广、费用统计、数据查询、素材管理等腾讯广告服务。
      </p>

      <h4>2.您的权利和义务</h4>

      <h4>2.1账号</h4>
      <p>
        2.1.1您应当通过登录服务市场网站或腾讯其他指定途径，使用您合法注册并拥有使用权的QQ号码或微信号码注册腾讯广告营销服务市场服务商账号（以下简称：“账号”），
        <strong>账号一经注册成功，该账号不可转让、赠与、继承或以其它方式交由他人使用。</strong>
      </p>
      <p>
        2.1.2为保障本服务的合法性及安全性，
        <strong>
          您不得违反本协议约定将您的账号用于其他目的，包括但不限于使用您的账号为第三方产品申请本服务等。否则，腾讯有权随时单方限制、中止或终止向您及/或您的产品提供本服务，且未经腾讯同意您及/或您的产品不得再次使用本服务。
        </strong>
      </p>
      <p>
        2.1.3您填写的QQ号码、微信号码，是您登录及使用本服务的凭证。您应当做好QQ号码、微信号码、密码以及进入和管理本服务中的各类产品与服务的口令、密码等的保密措施。
        <strong>
          因您保密措施不当或您的其他行为，致使上述口令、密码等丢失或泄漏所引起的一切损失和后果，均由您自行承担。
        </strong>
      </p>
      <p>
        <strong>
          2.1.4您保证：您填写的QQ号码、微信号码均是合法的。前述QQ号码、微信号码在本服务中进行的包括但不限于以下事项：注册本服务账号、提交相应资质材料、确认和同意相关协议和规则、选择具体服务类别以及进行费用结算等事项，均是您自行或您授权他人进行的行为，对您均有约束力。同时，您承担以前述QQ号码、微信号码为标识进行的全部行为的法律责任。
        </strong>
      </p>
      <p>
        2.1.5您理解并同意，为保护您及用户的数据安全，防止用户信息泄露、毁损、篡改或者丢失，
        <strong>
          腾讯有权对您的产品实行接入审查，包括但不限于技术水平审查、安全水平审查、主体资质审查等，并根据审查结果向您提出防入侵、防病毒等措施建议。若您的产品仍无法符合保护用户数据安全的要求，腾讯有权拒绝或终止提供本服务。
        </strong>
      </p>

      <h4>2.2资质材料</h4>
      <p>
        <strong>
          2.2.1您保证：您如实填写和提交账号注册与认证资料（包括但不限于主体资质材料以及联系人姓名、地址、电子邮箱等相关资料），并对资料的真实性、合法性、准确性和有效性承担责任；您具备使用本服务、接入和运营产品及提供相关服务等行为的相关合法资质；您提供的主体资质材料、相关资质或证明以及其他任何文件等信息真实、准确、完整，并在信息发生变更后，及时进行更新；您具备履行本协议项下之义务、各种行为的能力；您履行相关义务、从事相关行为不违反任何对您的有约束力的法律文件。否则，腾讯有权拒绝或终止提供本服务，并依照本协议对您进行处罚，且您应独自承担由此带来的一切责任及给第三方、腾讯造成的全部损失。
        </strong>
      </p>
      <p>
        2.2.2您保证：您在服务市场上通过您的产品提供的各种服务，依法已经具有相关的合法资质或获得了有关部门的许可或批准，并会向腾讯提交相关资质或证明文件。
      </p>
      <p>
        <strong>
          2.2.3您保证：您在服务市场上通过您的产品提供的各种服务，符合国家相关法规的规定，不违反任何相关法规及相关协议、规则，也不会侵犯任何人的合法权益，同时，会依法、依约并按照腾讯的要求提供商标权、版权、专利权等相关证明文件。
        </strong>
      </p>

      <h4>2.3收费服务</h4>
      <p>
        <strong>
          2.3.1您在服务市场上通过您的产品向用户提供各种服务的，腾讯与您互不收取任何服务费用，且您目前亦不就上述服务向用户收取任何服务费用。如您今后需开始对用户收费的，您应自行与用户签署协议并通过线下收取款项或在您的产品内收取款项的方式进行结算。
        </strong>
      </p>
      <p>
        2.3.2腾讯可能会对部分免费服务开始收费，也可能根据实际需要对收费服务的收费标准、方式进行修改和变更。前述修改、变更或开始收费前，腾讯将在相应服务页面进行通知或公告。如果您不同意上述修改、变更或付费内容，则应书面通知腾讯终止本协议并停止使用本服务。您未书面通知腾讯终止本协议并继续使用本服务的，视为您同意修改变更后的收费方案。
      </p>

      <h4>2.4产品要求</h4>
      <p>2.4.1您应自行负责您的产品的创作、开发、编辑、加工、修改、测试、运营及维护等工作，并且自行承担相应的费用。</p>
      <p>
        2.4.2
        您的产品，应符合相关法规、技术规范或标准等，同时，还应符合服务市场对接入产品在技术、安全等方面的统一要求，以确保产品可以在服务市场安全、稳定的运营。
      </p>
      <p>
        <strong>
          2.4.3 您的产品如需使用腾讯广告Marketing
          API或本服务其他相关API的，您不得进行任何形式的更改。否则腾讯有权随时中止或终止向您提供本服务。
        </strong>
      </p>
      <p>2.4.4 您应当在产品中向相关权利人提供投诉途径，确保权利人在认为您侵犯其合法权益时可以向您主张权利。</p>
      <p>
        2.4.5{' '}
        <strong>
          您在服务市场上向用户提供的产品应为您自身开发、创作或获得合法授权运营并独立承担法律责任的产品，否则，腾讯有权随时单方限制、中止或终止向您及/或您所登记的产品提供本服务，且未经腾讯同意您及/或您的产品不得再次使用本服务。
        </strong>
      </p>
      <p>
        2.4.6
        为保障用户对产品进行正确的识别、辨别和区分，保障用户的知情权、选择权以及第三方的合法权益，您的产品名称应当与您的产品存在关联性，不得以任何形式侵犯他人合法权益，且每一个产品只能使用一个产品名称。您应当向腾讯提交真实、准确、完整的产品或网站信息，包括但不限于域名、链接、在其他第三方分配的账号、字段等，腾讯有权对此进行提取、分析、评估、比对，为对相关产品、网站进行真实性、合法性、安全性等审核提供校验、判断依据。
      </p>
      <p>
        2.4.7
        您应为服务市场用户提供适用于腾讯广告平台及服务市场等产品场景的特殊产品版本。如您为用户提供收费产品或服务的，应提供一定时间的免费试用期限，此试用期限不得少于同产品在其他售卖渠道的试用期限，具体试用期期限应与腾讯另行协商确定。试用期限内，用户有权随时终止使用您的产品及相关服务，您对此不收取任何费用；试用期届满后，用户有权自行决定终止使用您的产品或付费购买您的产品相关服务，具体费用、付款方式等相关事项您应与腾讯确认后与用户进行协商，并按本协议第2.3条约定处理付款等事宜。
      </p>

      <h4>2.5产品运营</h4>
      <p>
        <strong>2.5.1您应自行按照相关法规，运营您的产品，履行相关义务，并自行承担全部责任，包括但不限于：</strong>
      </p>
      <p>（1）依照相关法律法规的规定，保留相应的访问、使用等日志记录；</p>
      <p>（2）国家有权机关向您依法查询相关信息时，应积极配合提供；</p>
      <p>（3）主动履行其他您依法应履行的义务。</p>
      <p>
        <strong>2.5.2您保证：</strong>
      </p>
      <p>
        （1）您的产品、提供给用户的相关服务及发布的相关信息、内容等，不违反相关法律、法规、政策等的规定及本协议或相关协议、规则等，也不会侵犯任何人的合法权益；
      </p>
      <p>
        （2）您自行对您的产品中由用户使用产品服务产生的内容（包括但不限于留言、消息、评论、名称等）负责，保证其不违反相关法律、法规、政策的规定以及公序良俗等。否则，您应及时采取删除、断开连接或其他有效措施；
      </p>
      <p>
        （3）产品设计上应当重视用户体验，尊重用户知情权、选择权，产品服务应当坚持诚信原则，不误导、欺诈、混淆用户，尊重用户的隐私，不骚扰用户，不制造垃圾信息。
      </p>
      <p>
        <strong>
          2.5.3您不得从事任何包括但不限于以下的违反法规的行为，也不得为以下违反法规的行为提供便利（包括但不限于为用户的行为提供便利等）：
        </strong>
      </p>
      <p>（1）反对宪法所确定的基本原则的行为；</p>
      <p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的行为；</p>
      <p>（3）损害国家荣誉和利益的行为；</p>
      <p>（4）煽动民族仇恨、民族歧视，破坏民族团结的行为；</p>
      <p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的行为；</p>
      <p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的行为；</p>
      <p>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的行为；</p>
      <p>（8）侮辱或者诽谤他人，侵害他人合法权益的行为；</p>
      <p>（9）侵害他人知识产权、商业秘密等合法权利的行为；</p>
      <p>（10）恶意虚构事实、隐瞒真相以误导、欺骗他人的行为；</p>
      <p>（11）发布、传送、传播广告信息及垃圾信息；</p>
      <p>（12）其他法律法规禁止的行为。</p>

      <p>
        <strong>
          2.5.4您不得从事包括但不限于以下行为，也不得为以下行为提供便利（包括但不限于为您的用户的行为提供便利等）：
        </strong>
      </p>
      <p>（1）删除、隐匿、改变服务市场显示或其中包含的任何专利、著作权、商标或其他所有权声明；</p>
      <p>（2）以任何方式干扰或企图干扰腾讯任何产品、任何部分或功能的正常运行，或者制作、发布、传播上述工具、方法等；</p>
      <p>
        （3）未经腾讯书面许可，在产品中使用包括但不限于“腾讯”、
        “QQ”、“微信”、“WeChat”、“腾讯广告”或其他腾讯商标标识或其任何变体、缩写、改写等；
      </p>
      <p>（4）避开、尝试避开或声称能够避开任何内容保护机制，或导致用户认为其直接与腾讯相关产品进行交互；</p>
      <p>（5）在未获得腾讯书面许可的情况下，以任何方式使用或为第三方产品申请使用腾讯URL地址、技术接口等；</p>
      <p>（6）在未经过用户同意的情况下，向任何其他用户及他方显示或以其他任何方式提供该用户的任何信息；</p>
      <p>
        （7）未经腾讯及用户授权，请求、收集、索取或以其他方式获取用户QQ、微信等腾讯服务的登录账号、密码或其他任何身份验证凭据，包括但不限于QQ号码、微信账号等；
      </p>
      <p>（8）为任何用户自动登录到服务市场提供代理身份验证凭据；</p>
      <p>（9）提供跟踪功能，包括但不限于识别其他用户在个人主页上查看、点击等操作行为；</p>
      <p>（10）自动将浏览器窗口定向到其他网页；</p>
      <p>（11）未经授权获取对腾讯产品或服务的访问权；</p>
      <p>（12）产品中含有计算机病毒、木马或其他恶意程序等任何可能危害腾讯或用户权益和终端信息安全等的内容；</p>
      <p>（13）设置或发布任何违反相关法规、公序良俗、社会公德等的功能或内容等；</p>
      <p>
        （14）公开表达或暗示，您与腾讯之间存在合作关系，包括但不限于相互持股、商业往来或合作关系等，或声称腾讯对您的认可；
      </p>
      <p>
        （15）填写和提交账号注册与认证资料违反本协议规定，或申请认证资料与注册信息内容不一致，以及运营行为与注册或认证信息所公示身份无关的；
      </p>
      <p>
        （16）以包括但不限于实物或虚拟物品奖励、胁迫、煽动用户分享等任何形式，实施强制、诱导其他用户关注账号、点击链接页面、打开产品程序APP或分享信息等强制、诱导行为的；
      </p>
      <p>（17）提供任何主动设置或引导用户以隐藏、掩饰、更改等方式不披露用户真实身份的通讯、社交、信息交互的服务；</p>
      <p>
        （18）基于提升、补充、帮助您的相关业务等原因，滥用公众账号第三方平台等功能，实现包括但不限于验证用户身份或资格、触及或获取用户的信息内容等行为；
      </p>
      <p>（19）其他腾讯认为不应该、不适当的行为、内容。</p>
      <p>
        2.5.5本服务中可能会使用第三方软件或技术，若有使用，腾讯将按照相关法规或约定，对相关的协议或其他文件，进行展示。前述通过各种形式展现的相关协议或其他文件，均是本协议不可分割的组成部分，与本协议具有同等的法律效力，您应当遵守这些要求。
        <strong>
          否则，因此带来的一切责任您应自行承担。如因本服务使用的第三方软件或技术引发的任何纠纷，由该第三方负责解决。
        </strong>
      </p>
      <p>
        2.5.6
        您的产品在服务市场上运营期间，您需向用户提供及时有效的客户服务，客户服务形式包括但不限于通过明确且合理的方式告知用户客户服务渠道、提供QQ/电话等，并自行承担客服费用。
      </p>
      <p>
        <strong>
          2.5.7
          您清楚知悉并理解，若因您违反本协议等相关协议规则，或基于本协议第5条“服务的中止或终止”等原因，腾讯部分或全部停止向您提供本服务后，您应当遵守以下约定：
        </strong>
      </p>
      <p>
        <strong>（1）您不得以其他任何形式提供或实现与此等服务具有同等效果的功能；</strong>
      </p>
      <p>
        <strong>（2）您应当立即删除您的产品中与被停止服务相关的插件、按钮、图标等内容或标识；</strong>
      </p>
      <p>
        <strong>（3）您不得以任何形式在您的产品中对腾讯不再提供相关服务等情况发布调侃、不实等表述；</strong>
      </p>
      <p>
        <strong>
          （4）您不得以任何形式误导用户或第三方以为产品为腾讯提供或获得腾讯相关认可等，应在任何场合均明确说明您是该产品的实际提供方。
        </strong>
      </p>

      <h4>2.6用户数据</h4>
      <p>
        2.6.1
        就您的产品或所提供的服务所收集、储存、处理、使用的用户数据（包括用户收集的客户个人信息），和实施任何与这些数据有关的活动，您都应当遵守以下规则：
      </p>
      <p>
        （1）您应当遵守与腾讯的相关协议和所有现行法律法规和国家标准（包括涉及到个人信息的法律法规和国家标准），并且不得故意使任何用户违反这些法律法规和国家标准的规定。您应当向腾讯提供一切必要的信息以表明您的活动符合本协议第2.6条的要求，并同意配合腾讯或腾讯委托的第三方对您的合规进行审计或检查。
      </p>
      <p>
        （2）您应当建立并遵守一套完整的数据保护政策，这些政策能够清晰并准确地向用户说明您收集什么数据，如何使用这些数据，以及如何与腾讯或第三方共享这些数据。该套数据保护政策应符合现行法律法规及国家标准的要求，告知用户并取得用户同意。
      </p>
      <p>（3）如果要收集、储存、处理、使用、共享用户数据，您应当充分告知用户，并取得用户的授权。</p>
      <p>
        （4）您应当实施技术上及组织上的安全措施，以保护用户的数据免受未经授权的访问和使用，同时您应当定期测试此类安全措施的有效性。
      </p>
      <p>
        （5）当用户希望您删除其在您应于储存、使用的用户数据时，您应当向用户提供修改或删除其数据的途径和方法，以便他们可以自行完成修改或删除的操作，同时您应当确保相关数据是被彻底删除，无法被还原。
      </p>
      <p>（6）您应当协助腾讯对用户根据现行的法律法规所提出的要求作出回应。</p>
      <p>
        （7）在没有得到腾讯事先书面同意的情况下，禁止将腾讯共享的任何数据传送给其他任何单位或个人。所有相关数据的传送都只能在现行的个人信息保护和数据保护法律的允许的范围内进行。
      </p>
      <p>
        （8）若您的行为涉及处理个人信息的，您承诺：相关信息收集、处理等行为已获得相关个人的合法授权，您应严格按照法律法规、个人授权范围处理个人信息；相关信息处理行为，不会以任何形式侵犯任何第三方的合法权利（包括但不限于个人的知情权、选择权、人格权等），亦不会受到任何第三方质疑、不会与任何第三方发生纠纷。若涉及信息传输的，相关传输行为应采取必要的安全措施（包括但不限于采用加密手段），如传输过程中被任何第三方入侵、未经授权访问、篡改、非法获取而发生数据泄露的，由您独立承担全部法律责任。若腾讯认为必要时，有权要求您提供相关数据信息有权使用的证明（包括但不限于您获得其个人授权许可的相关授权协议、隐私政策等），您应立即配合腾讯提供相关证明、说明文件。若您未提供相关证明、说明文件，或腾讯判断上述证明、说明文件存在瑕疵或错误的，视为您违反本协议约定，腾讯有权随时终止本服务并主张您承担违约责任。
      </p>
      <p>
        2.6.2 经用户授权后，您可调用腾讯广告Marketing
        API以获取用户在腾讯广告服务平台的数据，此类数据包括但不限于用户的广告投放计划、广告素材、投放数据、效果数据等。经用户授权或指示后，您亦应按照用户指示将用户使用产品所产生的数据回传给腾讯，以便于用户在腾讯广告平台中使用上述数据。就前述API的调用及信息的获取、回传，您应在产品中通过协议或页面授权等合规形式获取用户的明示授权，确保获取、传输上述数据的行为不存在任何违法违规、侵犯用户或其他第三人合法权益的情况，否则因此产生的任何法律后果，由您独立承担。
      </p>
      <p>2.6.3未经腾讯及用户允许，您不得利用本服务所获得的数据实施或变相实施任何形式的推广、营销、广告行为。</p>
      <p>
        2.6.4如果腾讯认为您收集、使用用户数据的方式，可能损害用户权益、体验，腾讯有权要求您删除相关数据并不得再以该方式收集、使用用户数据。
      </p>
      <p>2.6.5腾讯有权限制或阻止您获取用户数据及服务市场运营数据。</p>
      <p>
        2.6.6服务市场运营数据的全部权利，归属腾讯，且是腾讯的商业秘密，依法属于用户享有的相关权利除外。未经腾讯事先书面同意，不得为本协议约定之外的目的使用前述数据，亦不得以任何形式将前述数据提供给他人。
      </p>
      <p>
        2.6.7您因任何原因停止使用本服务，或停止使用服务市场的，必须立即删除从服务市场中获得的所有数据（包括各种备份），且不得再以任何方式进行使用。
      </p>
      <p>
        2.6.8您应自行对因使用本服务而存储在腾讯服务器的各类数据等信息，在本服务之外，采取合理、安全的技术措施，确保其安全性，并对自己的行为（包括但不限于自行安装软件、采取加密措施或进行其他安全措施等）所引起的结果承担全部责任。
      </p>

      <h4>2.7法律责任</h4>
      <p>
        <strong>
          2.7.1您理解并同意：若腾讯自行发现或根据相关部门的信息、权利人的投诉等发现您可能存在侵犯他人合法权益情形的，腾讯有权根据一般人的认识自己独立判断，以认定您是否存在侵犯他人合法权益情形，若腾讯经过判断认为您存在侵犯他人合法权益情形的，腾讯有权随时单方采取以下一项或多项措施。
        </strong>
      </p>
      <p>（1）要求您立即更换、修改侵犯他人合法权益的相关内容；</p>
      <p>
        （2）对存在侵犯他人合法权益的产品或您名下的全部产品或任何一款产品采取封闭新用户入口、限制老用户登录等措施；{' '}
      </p>
      <p>
        （3）对存在侵犯他人合法权益的产品或您名下的全部产品或任何一款产品采取下线措施即终止产品使用服务市场的服务；{' '}
      </p>
      <p>（4）禁止您今后将您的任何新产品接入服务市场； </p>
      <p>（5）将您的行为对外予以公告；</p>
      <p>（6）追究您法律责任等其他处理措施。</p>
      <p>
        <strong>
          2.7.2您保证：您使用本服务及您的任何行为，不违反任何法律法规、本协议和相关协议、规则等。否则，您理解并同意：若腾讯自行发现或根据相关部门的信息、权利人的投诉等发现您可能存在违反前述保证情形的，腾讯有权根据一般人的认识自己独立判断，以认定您是否存在违反前述保证情形，若腾讯经过判断认为您存在违反前述保证情形的，腾讯有权随时单方采取以下一项或多项措施。
        </strong>
      </p>
      <p>（1）要求您立即更换、修改违反前述保证情形的相关内容；</p>
      <p>（2）对存在违反前述保证情形的产品或您名下的全部产品或任何一款产品采取封闭新用户入口、限制老用户登录等措施；</p>
      <p>（3）对存在违反前述保证情形的产品或您名下的全部产品或任何一款产品采取下线措施即终止产品使用服务市场的服务；</p>
      <p>（4）禁止您今后将您的任何新产品接入服务市场； </p>
      <p>（5）将您的行为对外予以公告； </p>
      <p>（6）追究您法律责任等其他处理措施。</p>
      <p>
        <strong>
          2.7.3若腾讯按照上述条款、本协议的其他相关约定或因您违反相关法律的规定，对您或您的产品采取任何行为或措施，所引起的纠纷、责任等（包括但不限于对用户造成的损失等）一概由您自行负责，造成您损失的，您应自行全部承担，造成腾讯或他人损失的，您也应自行承担全部责任。
        </strong>
      </p>
      <p>
        <strong>2.7.4您同意和理解：</strong>
      </p>
      <p>
        <strong>
          （1）腾讯是一个中立的平台服务提供者，本协议项下仅向您提供开发服务开放接口或相关中立的技术支持服务，并且腾讯有权基于腾讯广告以及平台有序运营、健康发展等因素选择使用本服务的您。
        </strong>
      </p>
      <p>
        <strong>
          （2）您的产品由您以自身名义开发或享有合法的运营权利，并独立承担全部责任。腾讯不会、也不可能参与您的产品的研发、运营等任何活动，腾讯也不会对您的产品进行任何的修改、编辑或整理等。
        </strong>
      </p>
      <p>
        <strong>
          （3）因您的产品及服务产生的任何纠纷、责任等，以及您违反相关法律法规或本协议约定引发的任何后果，均由您独立承担责任、赔偿损失，与腾讯无关。如侵害到腾讯或他人权益的，您须自行承担全部责任和赔偿一切损失。
        </strong>
      </p>
      <p>
        <strong>
          （4）腾讯并不参与到用户与您之间的交易行为之中，对于用户与您的交易行为产生的争议或任何法律后果不承担任何法律责任，应由您与用户自行协商解决。
        </strong>
      </p>

      <h4>3.腾讯的权利义务</h4>
      <p>
        <strong>
          3.1腾讯会根据您选择的服务类型向您提供相应的服务。您理解并同意，基于用户体验、腾讯广告平台运营安全、腾讯广告平台规则要求及健康发展等综合因素，腾讯有权选择提供服务或开展合作的对象，有权决定功能开放、数据接口和相关数据披露的对象和范围。如果您或您的产品存在以下情形，腾讯有权视具体情况中止或终止向您提供本服务：
        </strong>
      </p>
      <p>（1）违反法律法规或本协议规定的；</p>
      <p>（2）影响用户体验的；</p>
      <p>（3）存在安全隐患的；</p>
      <p>（4）与服务市场或腾讯广告平台已有主要功能或功能组件相似、相同，或可实现上述功能或功能组件的主要效用的；</p>
      <p>
        （5）界面、风格、功能、描述或用户体验与腾讯相关服务平台类似，可能造成用户认为其所使用的功能或服务来源于腾讯或经腾讯授权的；
      </p>
      <p>
        （6）未遵循公平、对等原则与腾讯开展合作的，包括但不限于您在自有产品或平台、其他第三方产品或平台及其他腾讯产品或平台对用户自主选择或正常使用腾讯产品进行禁止、阻碍、妨碍、误导或影响等；
      </p>
      <p>（7）不符合腾讯其他管理要求的。</p>
      <p>
        3.2腾讯有权开发、运营与您的产品相似或相竞争的产品，同时腾讯也不保证服务市场上不会出现第三方提供的与您的产品的功能相竞争的产品。
      </p>
      <p>3.3腾讯有权在包括但不限于产品介绍页或安装页面等，向用户阐述该产品为您开发以及由您向用户提供客户服务等。</p>
      <p>
        3.4腾讯可将本协议下的权利和义务的部分或全部转让给他人，如果您不同意腾讯的该转让，则有权停止使用本服务。否则，视为您对此予以接受。
      </p>
      <p>3.5您理解并同意：为向更多用户推广您的产品，腾讯有权采取以下行为，而无须再取得您的同意：</p>
      <p>（1）在服务市场以外的平台、网站等采取各种形式对您的相关服务进行宣传、推广；</p>
      <p>（2）有权基于本协议目的使用您及您的产品的LOGO、标识、名称、图片等相关素材。</p>

      <h4>4.不可抗力及免责</h4>
      <p>
        <strong>
          4.1您理解并同意：鉴于网络服务的特殊性，腾讯有权在无需通知您的情况下根据服务市场的整体运营情况或相关运营规范、规则等，随时变更、中止或终止部分或全部的服务，若由此给您造成损失的，您同意放弃追究腾讯的责任。
        </strong>
      </p>
      <p>
        <strong>
          4.2您理解并同意：为了向您提供更完善的服务，腾讯有权定期或不定期地对提供本服务的平台或相关设备进行检修、维护、升级等，此类情况可能会造成相关服务在合理时间内中断或暂停，若由此给您造成损失的，您同意放弃追究腾讯的责任。
        </strong>
      </p>
      <p>
        <strong>
          4.3您理解并同意：本服务是按照现有技术和条件所能达到的现状提供的。腾讯会尽最大努力向您提供本服务，确保服务的连贯性和安全性；但腾讯不能保证其所提供的服务毫无瑕疵，也无法随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。因此您同意：即使腾讯提供的服务存在瑕疵，但上述瑕疵是当时行业技术水平所无法避免的，其将不被视为腾讯违约，同时，由此给您造成的数据或信息丢失等损失的，您同意放弃追究腾讯的责任。
        </strong>
      </p>
      <p>
        <strong>
          4.4您理解并同意：在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、严重传染病流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，腾讯将努力在第一时间与相关单位配合，及时进行修复，若由此给您造成损失的，您同意放弃追究腾讯的责任。
        </strong>
      </p>
      <p>
        <strong>
          4.5您理解并同意：若由于对以下情形导致的服务中断或受阻，给您造成损失的，您同意放弃追究腾讯的责任：
        </strong>
      </p>
      <p>
        <strong>（1）黑客攻击、计算机病毒侵入或发作。</strong>
      </p>
      <p>
        <strong>（2）计算机系统遭到破坏、瘫痪或无法正常使用导致腾讯未能依约履行协议。</strong>
      </p>
      <p>
        <strong>（3）基础运营商或主管部门故障、调整导致之影响。</strong>
      </p>
      <p>
        <strong>（4）因政府管制而造成的暂时性关闭、服务调整等。</strong>
      </p>
      <p>
        <strong>（5）国家法律法规或者政策的颁布、调整、变更等导致的。</strong>
      </p>
      <p>
        <strong>（6）由于用户或您的原因（包括但不限于操作失误、系统故障等）导致的。</strong>
      </p>
      <p>
        <strong>（7）其它非腾讯过错造成的原因等。</strong>
      </p>

      <h4>5.服务的中止或终止</h4>
      <p>5.1如您书面通知腾讯不接受本协议或不接受对协议的修改的，腾讯有权立即中止或终止向您提供本服务。</p>
      <p>5.2因不可抗力因素导致您无法继续使用本服务或腾讯无法提供本服务的，腾讯有权随时终止协议。</p>
      <p>5.3本协议约定的其他中止或终止条件发生或实现的，腾讯有权随时中止或终止向您提供本服务。</p>
      <p>5.4由于您违反本协议约定，腾讯依约终止向您提供本服务后，您不得再直接或间接，或以他人名义注册使用本服务。</p>
      <p>
        <strong>
          5.5如本协议或本服务因为任何原因终止的，对于您的账号中的全部数据或您因使用本服务而存储在腾讯服务器中的数据等任何信息，腾讯可将该等信息保留或删除，包括服务终止前您尚未处理完的任何数据。
        </strong>
      </p>
      <p>
        <strong>
          5.6如本协议或本服务因为任何原因终止的，您应自行处理好关于数据等信息的备份以及与用户之间的相关事项的处理等，由此造成腾讯损失的，您应负责赔偿。
        </strong>
      </p>

      <h4>6.通知</h4>
      <p>
        6.1腾讯可能会以网页公告、网页提示、电子邮箱、手机短信、常规的信件传送、您注册的本服务账号的管理系统内发送站内信等方式中的一种或多种，向您送达关于本服务的各种规则、通知、提示等信息，该等信息一经腾讯采取前述任何一种方式公布或发送，即视为您已经收到。若您不同意的，应书面通知腾讯，否则视为您已经接受、同意，并对您产生约束力。
      </p>
      <p>
        <strong>
          6.2若由于您提供的电子邮箱、手机号码、通讯地址等信息错误，导致您未收到相关规则、通知、提示等信息的，您同意仍然视为您已经收到相关信息并受其约束，一切后果及责任由您自行承担。
        </strong>
      </p>

      <h4>7.知识产权</h4>
      <p>
        <strong>
          7.1腾讯在本服务中提供的信息内容（包括但不限于网页、文字、图片、音频、视频、图表等）的知识产权均归腾讯所有，依法属于他人所有的除外。除另有特别声明外，腾讯提供本服务时所依托软件的著作权、专利权及其他知识产权均归腾讯所有。腾讯在本服务中所使用的“腾讯广告”、“微信”、“WeChat”、微信图标及LOGO、“QQ”、“腾讯”、“TENCENT”及企鹅形象等商业标识，其著作权或商标权归腾讯所有。上述及其他任何腾讯依法拥有的知识产权均受到法律保护，未经腾讯书面许可，您不得以任何形式进行使用或创造相关衍生作品。
        </strong>
      </p>
      <p>
        7.2您仅拥有依照本协议约定合法使用本服务及腾讯广告Marketing API的权利，与腾讯广告Marketing
        API相关的著作权、专利权等相关全部权利归腾讯所有。未经腾讯书面许可，您不得违约或违法使用，不得向任何单位或个人出售、转让、转授权腾讯的代码、API及开发工具等。
      </p>

      <h4>8.其他</h4>
      <p>
        8.1本协议内容同时包括《腾讯服务协议》《腾讯广告Marketing
        API开发者服务协议》《QQ号码规则》《腾讯微信软件许可及服务协议》及腾讯可能不断发布的关于本服务的其他相关协议、规则等内容（下称“关联规则”）。上述关联规则内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。上述关联规则内容与本协议存在冲突的，以本协议为准。
        <strong>
          腾讯有权在必要时单方修改本协议或上述关联规则内容，相关内容变更后，如果您继续使用本服务，即视为您已接受修改后的相关内容。如果您不接受修改后的相关内容或对本协议或关联规则内容产生异议的，您应当以书面方式通知腾讯，并应停止使用本服务。
        </strong>
      </p>
      <p>
        <strong>8.2本协议签订地为中华人民共和国广东省深圳市南山区。</strong>
      </p>
      <p>
        <strong>8.3本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</strong>
      </p>
      <p>
        <strong>
          8.4若您和腾讯之间发生任何纠纷或争议，首先应友好协商解决；协商不成功的，双方均同意将纠纷或争议提交本协议签订地有管辖权的人民法院解决。
        </strong>
      </p>
      <p>
        <strong>8.5本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。（正文完）</strong>
      </p>

      <p className="right">腾讯公司</p>
    </div>
  );
};
